/**
 * A flexible tooltip-like message for conveying a message to
 * content authors in Sitecore's Experience Editor. Very flexible
 * with how it can be positions so as to "tag" something with a note.
 *
 * For example, if a feature is disabled in the Experience Editor (like
 * the LivePerson click-to-chat, for example), this component could
 * be used to communicate that for further clarity.
 */

import React from 'react';

import ExperienceEditorContext from 'core/sitecore/ExperienceEditorContext';
import { Icon, ICONS } from 'core/components/Icon';

import * as S from './ExperienceEditorMessage.style';

type ManualPositionType = {
	top?: string;
	left?: string;
	right?: string;
	bottom?: string;
};

export type PositionType =
	| 'inline'
	| 'block'
	| 'top-right'
	| 'top-left'
	| 'bottom-right'
	| 'bottom-left'
	| ManualPositionType;

interface IProps {
	message: string;
	margin?: string;
	position?: PositionType;
}

const ExperienceEditorMessage = ({
	message,
	position = 'top-right',
	margin,
}: IProps) => (
	<ExperienceEditorContext.Consumer>
		{(isEE: boolean) =>
			isEE && (
				<S.Message title={message} {...{ position, margin }}>
					<Icon name={ICONS.HELP} size={16} />
				</S.Message>
			)
		}
	</ExperienceEditorContext.Consumer>
);

export default ExperienceEditorMessage;
